var React = require('react');

function ChevronWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.77767 17.3824C8.05535 17.661 8.50624 17.6617 8.78477 17.384C9.0633 17.1063 9.06399 16.6554 8.78631 16.3769L3.43276 11.0069C3.15508 10.7284 2.70418 10.7277 2.42565 11.0054C2.14712 11.2831 2.14643 11.734 2.42411 12.0125L7.77767 17.3824ZM8.79291 2.17266C9.07019 1.89373 9.06885 1.44284 8.78992 1.16556C8.51099 0.888283 8.0601 0.88962 7.78282 1.16855L0.207086 8.78937C-0.0701931 9.0683 -0.068855 9.5192 0.210074 9.79648C0.489003 10.0738 0.939898 10.0724 1.21718 9.79349L8.79291 2.17266Z","fill":"white"}));
}

ChevronWhite.defaultProps = {"width":"9","height":"18","viewBox":"0 0 9 18","fill":"none"};

module.exports = ChevronWhite;

ChevronWhite.default = ChevronWhite;
